import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme, Grid, } from "@mui/material";
import img1 from "./img/firstImg.png";
import img2 from "./img/secondimg.png";
import img3 from "./img/thirdImg.png";
import img4 from "./img/fourthImg.png";
import CustomizationMobile from "./CustomizationMobile";

const steps = [
  {
    step: 1,
    title: "Sign up on Vertex Suite",
    description:
      "Create a Vertex Suite account and connect your official WhatsApp number to it. Get your business verified with Facebook Business Manager.",
    image: img1,
  },
  {
    step: 2,
    title: "Optimize your profile",
    description:
      "Upload your brand kit to reflect brand identity and import your contacts.",
    image: img2,
  },
  {
    step: 3,
    title: "Access Vertex Suite tools",
    description:
      "Set up all necessary features such as chatbots, drip marketing sequences, broadcasts, integrations, etc., for your marketing campaigns.",
    image: img3,
  },
  {
    step: 4,
    title: "Provide user access",
    description:
      "Assign team roles such as Owner, Admin and Member to streamline operations.",
    image: img4,
  },
];

const Customizesection = () => {
  const [activeStep, setActiveStep] = useState(1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <CustomizationMobile/>
      <Box
        sx={{
          display: {xs: 'none', lg: 'flex'},
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            py: { xs: 6, md: 10 },
            px: { xs: 2, sm: 4, md: 8 },
            backgroundColor: "#fff",
            width: { xl: "74%", lg: "96%", md: "90%", sm: "90%" },
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            sx={{ fontSize: { xs: "24px", md: "36px" }, mb: 6 }}
          >
            How to use Vertex Suite WhatsApp marketing software
          </Typography>

          {/* Divider Bar with 4 Sections */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              position: "relative",
              mb: 8,
              px: 1,
            }}
          >
            {steps.map((item) => (
              <Box
                key={item.step}
                onClick={() => setActiveStep(item.step)}
                sx={{
                  flex: 1,
                  textAlign: "center",
                  cursor: "pointer",
                  position: "relative",
                  borderBottom: activeStep === item.step ? "4px solid #2563eb" : "2px solid #7A7A7A",
                  pb: 4,
                  mx: 1,
                  transition: "all 0.3s ease",
                }}
              >
                {/* Blurred Number Circle */}
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    backgroundColor: "#2563eb",
                    color: "#fff",
                    fontWeight: "bold",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mx: "auto",
                    mb: 1,
                    // boxShadow: "0 0 10px rgba(37, 99, 235, 0.6)",
                  }}
                >
                  {item.step}
                </Box>

                {/* Step Title & Description */}
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx=
                  {{
                    //  px: 2,
                    display: { xs: "none", md: "block" }
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Dynamic Image Section */}
          <Box
            component="img"
            src={steps.find((s) => s.step === activeStep)?.image}
            alt={`Step ${activeStep} image`}
            sx={{
              width: "100%",
              maxHeight: "500px",
              objectFit: "cover",
              borderRadius: 3,
              boxShadow: 4,
              transition: "all 0.5s ease",
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Customizesection;
